import TabelaFiscal, { COLUNA_DETALHES, CelulaDetalhes, Cliente, dataHora, moeda } from "../../_components/tabela-fiscal";
import Badge from "../../_components/badge";
import { MODELOS, STATUS } from "../../status";

const COLUNAS = [
	{ rotulo: "Modelo", classe: "text-center w-20" },
	{ rotulo: "Número", classe: "text-center w-24" },
	{ rotulo: "Série", classe: "text-center w-16" },
	{ rotulo: "Venda", classe: "text-center w-24" },
	{ rotulo: "Cliente", classe: "text-left" },
	{ rotulo: "Emissão", classe: "text-center w-36" },
	{ rotulo: "Valor", classe: "text-right w-28" },
	{ rotulo: "Status", classe: "text-center w-32" },
	COLUNA_DETALHES,
];

const FACA_UMA_PESQUISA = "Utilize o botão Listar para buscar documentos fiscais no período desejado.";
const NENHUM_DOCUMENTO = "Nenhum documento encontrado no período.";

export default function TabelaDocumentos({ documentos, total, pagina, totalPaginas, onPagina, carregando, onAcao, jaBuscou }) {
	return (
		<TabelaFiscal
			colunas={COLUNAS}
			total={total}
			pagina={pagina}
			totalPaginas={totalPaginas}
			onPagina={onPagina}
			carregando={carregando}
			vazio={jaBuscou ? NENHUM_DOCUMENTO : FACA_UMA_PESQUISA}
		>
			{documentos.map((doc) => {
				const abrir = () => onAcao("visualizar", doc);

				return (
					<tr
						key={`${doc.modelo}-${doc.serie}-${doc.numero}`}
						onClick={abrir}
						className="group hover:bg-customBlue-primary/5 cursor-pointer"
					>
						<td className="text-center align-middle text-sm text-gray-600">{MODELOS[doc.modelo]}</td>
						<td className="text-center align-middle font-semibold text-gray-800">{doc.numero}</td>
						<td className="text-center align-middle text-sm text-gray-500">{doc.serie}</td>
						<td className="text-center align-middle text-sm text-gray-500">{doc.id_venda ?? "—"}</td>
						<td className="text-left align-middle">
							<Cliente nome={doc.cliente} documento={doc.dest_cpfcnpj} />
						</td>
						<td className="text-center align-middle text-sm">{dataHora(doc.data_emissao)}</td>
						<td className="text-right align-middle font-semibold text-gray-800">{moeda(doc.valor_total)}</td>
						<td className="text-center align-middle">
							<Badge {...STATUS[doc.status]} />
						</td>
						<CelulaDetalhes onAbrir={abrir} />
					</tr>
				);
			})}
		</TabelaFiscal>
	);
}
